import { cva } from "../../../node_modules/.pnpm/class-variance-authority@0.7.1/node_modules/class-variance-authority/dist/index.js";
import { cn } from "../../../lib/utils.js";
const switchVariants = cva(
  cn`
    peer inline-flex h-[1.15rem] w-8 shrink-0 items-center rounded-full border border-transparent shadow-xs transition-all
    outline-none disabled:cursor-not-allowed disabled:opacity-50
    focus-visible:ring-[3px] focus-visible:border-ring focus-visible:ring-ring/50 
    data-[state=checked]:bg-primary
    data-[state=unchecked]:bg-input dark:data-[state=unchecked]:bg-input/80
  `
), switchThumbVariants = cva(
  cn`
    bg-background pointer-events-none block size-4 rounded-full ring-0 transition-transform 
    dark:data-[state=checked]:bg-primary-foreground data-[state=checked]:translate-x-[calc(100%-2px)]
    dark:data-[state=unchecked]:bg-foreground  data-[state=unchecked]:translate-x-0 
  `
);
export {
  switchThumbVariants,
  switchVariants
};
//# sourceMappingURL=variants.js.map
